var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCepiDajthtas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 89,
    height: 81.204,
    viewBox: "0 0 89 81.204",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.55,
    y1: 0.95,
    x2: 1.488,
    y2: 0.006,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.051,
    stopColor: "#b9752b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#f9d877"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#e0b254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.424,
    stopColor: "#ca9036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    stopColor: "#c2842b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#cd953a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "#eac162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#f9d877"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    stopColor: "#ecc468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#d09947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#bf7e32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#b9752b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7844",
    "data-name": "Group 7844",
    transform: "translate(0 81.204) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9583",
    "data-name": "Path 9583",
    d: "M112.946,332.183V281.926L131.579,261.5v89h-81.2l16.717-18.322Z",
    transform: "translate(-50.375 -261.505)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9584",
    "data-name": "Path 9584",
    d: "M110.627,340.665V288.014L124.1,273.248v80.8H50.375l12.213-13.385Z",
    transform: "translate(-42.895 -265.051)",
    fill: "#1d3943"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCepiDajthtas);
export default __webpack_public_path__ + "static/media/cepi_dajthtas.84616c5290b3a1bc6836e1329f5b5fe2.svg";
export { ForwardRef as ReactComponent };